export default __webpack_public_path__ + "audio/slots/lose.wav";